import React from 'react'
import "./Help.css"
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next';
import ArrowButton from '../../Components/Common/ArrowButton.js';
import { useThemeContext } from '../../Context/ThemeContext.js';
import { DARKCOLORS, LIGHTCOLORS, ROUTES } from '../../Utils/constants.js';
import { useNavigate } from 'react-router-dom';
import Cloudvedio from './Cloudvedio/cloudvedio.js';

function Help() {
  const { mode } = useThemeContext();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const containerBG = mode === 'dark' ? DARKCOLORS.BackgroundMenu : LIGHTCOLORS.BackgroundMenu;
  const cardsBackground = mode === 'dark' ? DARKCOLORS.GreyScale10 : LIGHTCOLORS.GreyScale10;
  const headingcolor = mode === 'dark' ? DARKCOLORS.HeadingDarkBackground : LIGHTCOLORS.HeadingDarkBackground;
  const iconsColor = mode === 'dark' ? DARKCOLORS.GreyScale80 : LIGHTCOLORS.GreyScale80;

  const Vector1 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="34" viewBox="0 0 31 34" fill="none">
      <path d="M19.5278 5V8.2C19.5278 9.96 20.9778 11.4 22.75 11.4H25.9722M9.05556 18.6H15.5M9.05556 25H21.9444M30 9V25C30 29.8 27.5833 33 21.9444 33H9.05556C3.41667 33 1 29.8 1 25V9C1 4.2 3.41667 1 9.05556 1H21.9444C27.5833 1 30 4.2 30 9Z"
        stroke={iconsColor} stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );

  const Vector2 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path d="M15.9973 1.4999C11.9928 1.4999 8.36737 3.12359 5.7429 5.74669C3.11843 8.36979 1.49591 11.995 1.49591 16.0006C1.49591 20.0049 3.11968 23.6302 5.7429 26.2545C8.36613 28.8789 11.9915 30.5013 15.9973 30.5013C17.1079 30.5013 18.184 30.3788 19.2103 30.1465C20.2737 29.9065 21.2924 29.5491 22.251 29.0908C22.6429 28.9032 23.0374 28.7921 23.4369 28.7564C23.8365 28.7206 24.2424 28.7615 24.6599 28.8764L26.8312 29.4776C27.1835 29.5746 27.532 29.5771 27.8563 29.4929C28.178 29.4074 28.4792 29.2325 28.7371 28.9747C28.9962 28.7143 29.1698 28.413 29.2541 28.0914C29.337 27.7697 29.3319 27.4212 29.2336 27.0664L28.6771 25.0865C28.5571 24.6577 28.5175 24.2339 28.5596 23.8126C28.6018 23.3888 28.723 22.9804 28.9247 22.5847C29.4404 21.5763 29.84 20.5066 30.1055 19.3948C30.3647 18.3149 30.5012 17.1789 30.5012 16.0032C30.5012 11.9989 28.8775 8.3736 26.2542 5.74926C23.631 3.12485 20.0057 1.50247 15.9998 1.50247L15.9973 1.4999ZM10.5337 13.1949C10.5337 13.6085 10.198 13.9455 9.78307 13.9455C9.36948 13.9455 9.03246 13.6098 9.03246 13.1949C9.03246 11.2725 9.81241 9.53141 11.0724 8.27169C12.3323 7.01053 14.0735 6.23189 15.9958 6.23189C17.9183 6.23189 19.6595 7.01181 20.9193 8.27169C22.1805 9.53158 22.9592 11.2727 22.9592 13.1949C22.9592 15.1173 22.1792 16.8584 20.9205 18.1194C19.8265 19.2134 18.37 19.9448 16.7464 20.1184V21.7306C16.7464 22.1441 16.4107 22.4811 15.9958 22.4811C15.5822 22.4811 15.2452 22.1454 15.2452 21.7306V19.4087C15.2452 18.9951 15.5809 18.6581 15.9958 18.6581C17.5047 18.6581 18.8718 18.0467 19.8598 17.0587C20.8478 16.0707 21.4593 14.7036 21.4593 13.1949C21.4593 11.6861 20.8478 10.3203 19.8598 9.33107C18.8705 8.34309 17.5046 7.73166 15.9958 7.73166C14.4869 7.73166 13.1211 8.34309 12.1318 9.33107C11.1438 10.3203 10.5323 11.6861 10.5323 13.1949L10.5337 13.1949ZM15.248 24.4586C15.248 24.045 15.5837 23.708 15.9986 23.708C16.4122 23.708 16.7492 24.0437 16.7492 24.4586V25.0176C16.7492 25.4312 16.4135 25.7682 15.9986 25.7682C15.585 25.7682 15.248 25.4325 15.248 25.0176V24.4586ZM4.68344 4.68597C7.5799 1.78966 11.5794 0 15.9986 0C20.4169 0 24.4174 1.7909 27.3138 4.68597C30.2103 7.58229 32 11.5816 32 16.0006C32 17.2784 31.8468 18.5306 31.557 19.7383C31.2596 20.9828 30.8192 22.1636 30.2588 23.2639C30.1388 23.4987 30.0686 23.7285 30.0456 23.957C30.0226 24.188 30.0469 24.4293 30.1171 24.6807L30.6737 26.6605C30.8447 27.2707 30.8498 27.886 30.7005 28.4642C30.5498 29.0424 30.2447 29.5773 29.798 30.0266C29.3486 30.4772 28.815 30.7848 28.238 30.938C27.6623 31.0912 27.0471 31.0873 26.4343 30.9176L24.2642 30.3164C24.0281 30.2513 23.797 30.2283 23.5685 30.2487C23.3413 30.2678 23.1179 30.3317 22.8983 30.4363C21.8363 30.9457 20.7116 31.3388 19.5412 31.6043C18.3961 31.8634 17.2102 32 16.0014 32C11.5831 32 7.58256 30.2091 4.6862 27.314C1.78974 24.4177 0 20.4184 0 15.9994C0 11.5814 1.79098 7.58098 4.6862 4.68476L4.68344 4.68597Z" fill={iconsColor} />
    </svg>
  );

  const Vector3 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="34" viewBox="0 0 30 34" fill="none">
      <path d="M14.9837 17.8061C16.7819 17.8061 18.2395 16.3732 18.2395 14.6057C18.2395 12.8382 16.7819 11.4053 14.9837 11.4053C13.1856 11.4053 11.7279 12.8382 11.7279 14.6057C11.7279 16.3732 13.1856 17.8061 14.9837 17.8061ZM14.9837 17.8061V22.6067M12.5256 1.37205L4.40233 4.38042C2.53023 5.06851 1 7.24478 1 9.19702V21.0865C1 22.9747 2.26977 25.4551 3.81628 26.5912L10.8163 31.7278C13.1116 33.4241 16.8884 33.4241 19.1837 31.7278L26.1837 26.5912C27.7302 25.4551 29 22.9747 29 21.0865V9.19702C29 7.22878 27.4698 5.05251 25.5977 4.36442L17.4744 1.37205C16.0907 0.875985 13.8767 0.875985 12.5256 1.37205Z"
        stroke={iconsColor} stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
  return (
    <div className='help-containexr'
      style={{ backgroundColor: containerBG }}>
      <Box>
        <p style={{
          color: { headingcolor }
        }} className='help-title'> {t('help.helpTitle')}</p>
        <p className='help-subtitle'>{t('help.helpsubTitle')}</p>
      </Box>
      <Box className='help_video_sec'>
{/* 
        <Box className="help-video-container" >

          <Cloudvedio />
        </Box> */}

        <div className='help-grid'>
          <Box className='help-card'
            sx={{
              bgcolor: cardsBackground,
              height: "300px",
              padding: '20px',
              display: 'flex', justifyContent: 'space-between', flexDirection: 'column',
              borderRadius: '12px',

            }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center" }}>
              <Vector1 />
              <div onClick={() => navigate(ROUTES.Documentation)}>
                <ArrowButton sx={{ alignSelf: "end" }} />
              </div>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'end', flexDirection: 'column', }}>
              <p style={{ marginBottom: '10px', fontSize: '18px', }} className=''> {t('help.documentation')}</p>
            </Box>
          </Box>

          <Box className='help-card '
            sx={{
              bgcolor: cardsBackground,
              height: "300px",
              padding: '20px',
              display: 'flex', justifyContent: 'space-between', flexDirection: 'column',
              borderRadius: '12px',

            }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center" }}>
              <Vector2 />
              <div onClick={() => navigate(ROUTES.Faq)}>
                <ArrowButton sx={{ alignSelf: "end", }} />
              </div>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'end', flexDirection: 'column', }}>
              <p style={{ marginBottom: '10px', fontSize: '18px', }} className=''>{t('help.faq')}</p>
            </Box>
          </Box>

          <Box className='help-card '
            sx={{
              bgcolor: cardsBackground,
              height: "300px",
              padding: '20px',
              display: 'flex', justifyContent: 'space-between', flexDirection: 'column',
              borderRadius: '12px',

            }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center" }}>
              <Vector3 />
              <div onClick={() => navigate(ROUTES.TrustSafety)}>
                <ArrowButton sx={{ alignSelf: "end", }} />
              </div>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'end', flexDirection: 'column', }}>
              <p style={{ marginBottom: '10px', fontSize: '18px', }} className=''>{t('help.trustandsafety')}</p>
            </Box>
          </Box>
          {/* <Box className='help-card '

          sx={{
            bgcolor: cardsBackground,
            height: "300px",
            padding: '20px',
            display: 'flex', justifyContent: 'space-between', flexDirection: 'column',
            borderRadius: '12px',

          }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center" }}>
            <Vector3 />
            <div onClick={() => navigate(ROUTES.Term)}>
              <ArrowButton sx={{ alignSelf: "end", }}/>
            </div>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'end', flexDirection: 'column', }}>
            <p style={{ marginBottom: '10px', fontSize: '18px', }} className=''>terms</p>
          </Box>
        </Box> */}

        </div>
      </Box>



    </div>
  )
}

export default Help